import OrderItem from 'orders/presentation/components/atoms/OrderItem/OrderItem'
import OrderList from 'components/molecules/OrderList/OrderList'
import { Order } from '../../../store/interfaces/order'

interface Props {
    orders: Order[]
    onOrderStateChanged?: () => void
}

export default function OrdersList({ orders, onOrderStateChanged }: Props) {
    return <OrderList component={OrderItem} list={orders} onOrderStateChanged={onOrderStateChanged} />
}
